var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (true)?_c('div',{staticClass:"flex-centered-col --ml25 --mr25 --mb12"},[_c('br'),_c('object',{attrs:{"data":"https://www.youtube.com/embed/Wm5QGq6QpAM","id":"gbsDemo"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }